import { Amplify } from 'aws-amplify';

export const s3Config = {
	s3 : {
		REGION                  : 'ap-south-1',
		BUCKET                  : 'instavc-uploads',
		PROFILEBUCKET           : 'instavcprofileimages',
		INSTAVCRECORDINGSBUCKET : 'instavcrecordings',
		folder                  : 'content',
		chatfolder              : 'chat',
		CONTENTBUCKET           : 'instavc-content',
		webinarfolder           : 'webinar',
		vcBucket                : 'invc-vc',
		inapiBucket             : 'inapi-uploads'
	},
	API : {
		endpoints : [
			{
				name     : 'broadcastChatPost',
				endpoint : import.meta.env.VITE_InVcMainchatAPI,
				region   : import.meta.env.VITE_vcApiRegion
			},
			{
				name     : 'webinars',
				endpoint : import.meta.env.VITE_InvcWebinarApi,
				region   : import.meta.env.VITE_vcApiRegion
			}
		]
	},
	broadcastStreamingUrl : 'https://staging.invc.vc/broadcast'
};

Amplify.configure({
	API : {
		endpoints : [
			{
				name     : 'user',
				endpoint : import.meta.env.VITE_USERS,
				region   : import.meta.env.VITE_Analytics_Region
			},
			{
				name     : 'broadcastChatPost',
				endpoint : import.meta.env.VITE_InVcMainchatAPI,
				region   : import.meta.env.VITE_vcApiRegion
			},
			{
				name     : 'webinars',
				endpoint : import.meta.env.VITE_InvcWebinarApi,
				region   : import.meta.env.VITE_vcApiRegion
			},
			{
				name     : 'myFiles',
				endpoint : import.meta.env.VITE_MyFilesAPi,
				region   : import.meta.env.VITE_s3Region
			},
			{
				name     : 'analytics',
				endpoint : import.meta.env.VITE_Analytics,
				region   : import.meta.env.VITE_Analytics_Region
			},
			{
				name     : 'analyticsApi',
				endpoint : import.meta.env.VITE_Analytics,
				region   : import.meta.env.VITE_s3Region
			},
			{
				name     : 'pollingApi',
				endpoint : import.meta.env.VITE_USERS,
				region   : import.meta.env.VITE_s3Region
			}
		]
	}
});